import * as React from 'react';

export interface FeatureListProps {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Defines the number of columns. It is used to define how many features will be displayed in a single row.
   * Ignored when `mobile` is enabled on `<WixDesignSystemProvider/>` — features then stack
   * vertically in a single column.
   * @default 3
   */
  cols?: number;
  /**
   * Specifies an array of features. It accepts following properties:
   *  * `image` - use to pass a visual representation of a feature
   *  * `title` - use to specify feature title
   *  * `text` - use to specify a short feature description.q
   */
  features?: FeatureType[];
}

export class FeatureList extends React.Component<FeatureListProps> {}

export type FeatureType = {
  image: React.ReactNode;
  title: string;
  text: string;
};
